var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEspino(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 14q-.825 0-1.412-.587T2 12V3q0-.825.588-1.412T4 1h16q.825 0 1.413.588T22 3v9q0 .825-.587 1.413T20 14h-3.225q.15-.5.2-1t0-1q-.2-1.9-1.612-3.2T12 7.5T8.637 8.8T7.025 12q-.05.5 0 1t.2 1zm3-5.5l2-2l-2-2l-2 2zM16.5 7q.625 0 1.063-.437T18 5.5t-.437-1.062T16.5 4t-1.062.438T15 5.5t.438 1.063T16.5 7M5 23v-2.1q0-.875.488-1.625t1.287-1.125q1.225-.575 2.55-.862T12 17t2.675.288t2.55.862q.8.375 1.288 1.125T19 20.9V23zm7-7q-1.45 0-2.475-1.025T8.5 12.5t1.025-2.475T12 9t2.475 1.025T15.5 12.5t-1.025 2.475T12 16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEspino);
export default __webpack_public_path__ + "static/media/ic_espino.0f4f6a4cc5ea5ef4727cf4210e44ddf9.svg";
export { ForwardRef as ReactComponent };